// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_wrk_ctx = require("./MM_wrk_ctx.bs.js");
var MM_asrt_apply = require("../mm-utils/MM_asrt_apply.bs.js");
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");

var procName = "MM_wrk_search_asrt";

function frameMatchesPatternPriv(frm, pat, aIdx, pIdx) {
  var asrtLen = frm.asrt.length;
  if (pIdx >= pat.length) {
    return true;
  }
  if (aIdx >= asrtLen) {
    return false;
  }
  var aIdx$1 = aIdx;
  var matchFound = false;
  while(!matchFound && aIdx$1 < asrtLen) {
    if (Caml_array.get(frm.asrt, aIdx$1) < 0 && Caml_array.get(frm.asrt, aIdx$1) === Caml_array.get(pat, pIdx) || Caml_array.get(frm.asrt, aIdx$1) >= 0 && Caml_array.get(frm.varTypes, Caml_array.get(frm.asrt, aIdx$1)) === Caml_array.get(pat, pIdx)) {
      matchFound = frameMatchesPatternPriv(frm, pat, aIdx$1 + 1 | 0, pIdx + 1 | 0);
    }
    aIdx$1 = aIdx$1 + 1 | 0;
  };
  return matchFound;
}

function frameMatchesPattern(frm, pat) {
  return frameMatchesPatternPriv(frm, pat, 0, 0);
}

function searchAssertions(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, label, typ, pattern, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              MM_wrk_ctx.beginWorkerInteractionUsingCtx(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, procName, /* FindAssertions */{
                    label: label.toLowerCase(),
                    typ: typ,
                    pattern: pattern
                  }, (function (resp, sendToWorker, endWorkerInteraction) {
                      if (resp.TAG === /* OnProgress */0) {
                        return Curry._1(onProgress, resp._0);
                      }
                      Curry._1(endWorkerInteraction, undefined);
                      Curry._1(resolve, resp.found);
                    }), false, undefined);
            });
}

function processOnWorkerSide(req, sendToClient) {
  var pattern = req.pattern;
  var typ = req.typ;
  var label = req.label;
  var results = [];
  var partial_arg = MM_wrk_ctx.getWrkCtxExn(undefined);
  MM_asrt_apply.applyAssertions(MM_context.getNumOfVars(MM_wrk_ctx.getWrkCtxExn(undefined)) - 1 | 0, MM_wrk_ctx.getWrkFrmsExn(undefined), (function (param, param$1) {
          return MM_context.isDisj(partial_arg, param, param$1);
        }), [], undefined, undefined, undefined, MM_wrk_ctx.getWrkParenCntExn(undefined), (function (frame) {
          if (frame.label.toLowerCase().includes(label) && Caml_array.get(frame.asrt, 0) === typ) {
            return frameMatchesPattern(frame, pattern);
          } else {
            return false;
          }
        }), (function (res) {
          results.push(res);
          return /* Continue */0;
        }), (function (pct) {
          Curry._1(sendToClient, {
                TAG: /* OnProgress */0,
                _0: pct
              });
        }), undefined);
  Curry._1(sendToClient, {
        TAG: /* SearchResult */1,
        found: results
      });
}

exports.procName = procName;
exports.searchAssertions = searchAssertions;
exports.processOnWorkerSide = processOnWorkerSide;
exports.frameMatchesPattern = frameMatchesPattern;
/* MM_context Not a pure module */
